import { render, staticRenderFns } from "./backup-settings-form.component.vue?vue&type=template&id=1b1f555a"
import script from "./backup-settings-form.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-settings-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1f555a')) {
      api.createRecord('1b1f555a', component.options)
    } else {
      api.reload('1b1f555a', component.options)
    }
    module.hot.accept("./backup-settings-form.component.vue?vue&type=template&id=1b1f555a", function () {
      api.rerender('1b1f555a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/backup-settings/backup-settings-form.component.vue"
export default component.exports